var _path, _path2, _path3, _g, _rect, _path4, _rect2, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _ellipse, _ellipse2, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _g2, _path36, _path37, _path38, _path39, _path40, _ellipse3, _ellipse4, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _g3, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _ellipse5, _path58, _path59, _path60, _path61, _path62, _path63, _ellipse6, _ellipse7, _ellipse8, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginRightImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 209,
    viewBox: "0 0 270 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.009 2.25865C127.009 3.4284 126.061 4.37668 124.891 4.37668C123.722 4.37668 122.773 3.4284 122.773 2.25865C122.773 1.0889 123.722 0.140625 124.891 0.140625C126.061 0.140625 127.009 1.0889 127.009 2.25865ZM127.009 17.2118C127.009 18.3816 126.061 19.3299 124.891 19.3299C123.722 19.3299 122.773 18.3816 122.773 17.2118C122.773 16.0421 123.722 15.0938 124.891 15.0938C126.061 15.0938 127.009 16.0421 127.009 17.2118ZM127.009 32.1578C127.009 33.3275 126.061 34.2758 124.891 34.2758C123.722 34.2758 122.773 33.3275 122.773 32.1578C122.773 30.988 123.722 30.0397 124.891 30.0397C126.061 30.0397 127.009 30.988 127.009 32.1578ZM127.009 47.1109C127.009 48.2807 126.061 49.229 124.891 49.229C123.722 49.229 122.773 48.2807 122.773 47.1109C122.773 45.9412 123.722 44.9929 124.891 44.9929C126.061 44.9929 127.009 45.9412 127.009 47.1109ZM127.009 62.0569C127.009 63.2266 126.061 64.1749 124.891 64.1749C123.722 64.1749 122.773 63.2266 122.773 62.0569C122.773 60.8871 123.722 59.9388 124.891 59.9388C126.061 59.9388 127.009 60.8871 127.009 62.0569ZM124.891 79.1281C126.061 79.1281 127.009 78.1798 127.009 77.0101C127.009 75.8403 126.061 74.892 124.891 74.892C123.722 74.892 122.773 75.8403 122.773 77.0101C122.773 78.1798 123.722 79.1281 124.891 79.1281ZM139.845 79.1281C141.014 79.1281 141.963 78.1798 141.963 77.0101C141.963 75.8403 141.014 74.892 139.845 74.892C138.675 74.892 137.727 75.8403 137.727 77.0101C137.727 78.1798 138.675 79.1281 139.845 79.1281ZM139.845 64.1749C141.014 64.1749 141.963 63.2266 141.963 62.0569C141.963 60.8871 141.014 59.9388 139.845 59.9388C138.675 59.9388 137.727 60.8871 137.727 62.0569C137.727 63.2266 138.675 64.1749 139.845 64.1749ZM139.845 49.229C141.014 49.229 141.963 48.2807 141.963 47.1109C141.963 45.9412 141.014 44.9929 139.845 44.9929C138.675 44.9929 137.727 45.9412 137.727 47.1109C137.727 48.2807 138.675 49.229 139.845 49.229ZM139.845 34.2758C141.014 34.2758 141.963 33.3275 141.963 32.1578C141.963 30.988 141.014 30.0397 139.845 30.0397C138.675 30.0397 137.727 30.988 137.727 32.1578C137.727 33.3275 138.675 34.2758 139.845 34.2758ZM139.845 19.3299C141.014 19.3299 141.963 18.3816 141.963 17.2118C141.963 16.0421 141.014 15.0938 139.845 15.0938C138.675 15.0938 137.727 16.0421 137.727 17.2118C137.727 18.3816 138.675 19.3299 139.845 19.3299ZM139.845 4.37668C141.014 4.37668 141.963 3.4284 141.963 2.25865C141.963 1.0889 141.014 0.140625 139.845 0.140625C138.675 0.140625 137.727 1.0889 137.727 2.25865C137.727 3.4284 138.675 4.37668 139.845 4.37668ZM156.909 77.0101C156.909 78.1798 155.96 79.1281 154.791 79.1281C153.621 79.1281 152.673 78.1798 152.673 77.0101C152.673 75.8403 153.621 74.892 154.791 74.892C155.96 74.892 156.909 75.8403 156.909 77.0101ZM169.744 79.1281C170.914 79.1281 171.862 78.1798 171.862 77.0101C171.862 75.8403 170.914 74.892 169.744 74.892C168.574 74.892 167.626 75.8403 167.626 77.0101C167.626 78.1798 168.574 79.1281 169.744 79.1281ZM156.909 62.0569C156.909 63.2266 155.96 64.1749 154.791 64.1749C153.621 64.1749 152.673 63.2266 152.673 62.0569C152.673 60.8871 153.621 59.9388 154.791 59.9388C155.96 59.9388 156.909 60.8871 156.909 62.0569ZM169.744 64.1749C170.914 64.1749 171.862 63.2266 171.862 62.0569C171.862 60.8871 170.914 59.9388 169.744 59.9388C168.574 59.9388 167.626 60.8871 167.626 62.0569C167.626 63.2266 168.574 64.1749 169.744 64.1749ZM156.909 47.1109C156.909 48.2807 155.96 49.229 154.791 49.229C153.621 49.229 152.673 48.2807 152.673 47.1109C152.673 45.9412 153.621 44.9929 154.791 44.9929C155.96 44.9929 156.909 45.9412 156.909 47.1109ZM169.744 49.229C170.914 49.229 171.862 48.2807 171.862 47.1109C171.862 45.9412 170.914 44.9929 169.744 44.9929C168.574 44.9929 167.626 45.9412 167.626 47.1109C167.626 48.2807 168.574 49.229 169.744 49.229ZM156.909 32.1578C156.909 33.3275 155.96 34.2758 154.791 34.2758C153.621 34.2758 152.673 33.3275 152.673 32.1578C152.673 30.988 153.621 30.0397 154.791 30.0397C155.96 30.0397 156.909 30.988 156.909 32.1578ZM169.744 34.2758C170.914 34.2758 171.862 33.3275 171.862 32.1578C171.862 30.988 170.914 30.0397 169.744 30.0397C168.574 30.0397 167.626 30.988 167.626 32.1578C167.626 33.3275 168.574 34.2758 169.744 34.2758ZM156.909 17.2118C156.909 18.3816 155.96 19.3299 154.791 19.3299C153.621 19.3299 152.673 18.3816 152.673 17.2118C152.673 16.0421 153.621 15.0938 154.791 15.0938C155.96 15.0938 156.909 16.0421 156.909 17.2118ZM169.744 19.3299C170.914 19.3299 171.862 18.3816 171.862 17.2118C171.862 16.0421 170.914 15.0938 169.744 15.0938C168.574 15.0938 167.626 16.0421 167.626 17.2118C167.626 18.3816 168.574 19.3299 169.744 19.3299ZM156.909 2.25865C156.909 3.4284 155.96 4.37668 154.791 4.37668C153.621 4.37668 152.673 3.4284 152.673 2.25865C152.673 1.0889 153.621 0.140625 154.791 0.140625C155.96 0.140625 156.909 1.0889 156.909 2.25865ZM169.744 4.37668C170.914 4.37668 171.862 3.4284 171.862 2.25865C171.862 1.0889 170.914 0.140625 169.744 0.140625C168.574 0.140625 167.626 1.0889 167.626 2.25865C167.626 3.4284 168.574 4.37668 169.744 4.37668ZM186.808 77.0101C186.808 78.1798 185.859 79.1281 184.69 79.1281C183.52 79.1281 182.572 78.1798 182.572 77.0101C182.572 75.8403 183.52 74.892 184.69 74.892C185.859 74.892 186.808 75.8403 186.808 77.0101ZM199.643 79.1281C200.813 79.1281 201.761 78.1798 201.761 77.0101C201.761 75.8403 200.813 74.892 199.643 74.892C198.473 74.892 197.525 75.8403 197.525 77.0101C197.525 78.1798 198.473 79.1281 199.643 79.1281ZM186.808 62.0569C186.808 63.2266 185.859 64.1749 184.69 64.1749C183.52 64.1749 182.572 63.2266 182.572 62.0569C182.572 60.8871 183.52 59.9388 184.69 59.9388C185.859 59.9388 186.808 60.8871 186.808 62.0569ZM199.643 64.1749C200.813 64.1749 201.761 63.2266 201.761 62.0569C201.761 60.8871 200.813 59.9388 199.643 59.9388C198.473 59.9388 197.525 60.8871 197.525 62.0569C197.525 63.2266 198.473 64.1749 199.643 64.1749ZM186.808 47.1109C186.808 48.2807 185.859 49.229 184.69 49.229C183.52 49.229 182.572 48.2807 182.572 47.1109C182.572 45.9412 183.52 44.9929 184.69 44.9929C185.859 44.9929 186.808 45.9412 186.808 47.1109ZM199.643 49.229C200.813 49.229 201.761 48.2807 201.761 47.1109C201.761 45.9412 200.813 44.9929 199.643 44.9929C198.473 44.9929 197.525 45.9412 197.525 47.1109C197.525 48.2807 198.473 49.229 199.643 49.229ZM186.808 32.1578C186.808 33.3275 185.859 34.2758 184.69 34.2758C183.52 34.2758 182.572 33.3275 182.572 32.1578C182.572 30.988 183.52 30.0397 184.69 30.0397C185.859 30.0397 186.808 30.988 186.808 32.1578ZM199.643 34.2758C200.813 34.2758 201.761 33.3275 201.761 32.1578C201.761 30.988 200.813 30.0397 199.643 30.0397C198.473 30.0397 197.525 30.988 197.525 32.1578C197.525 33.3275 198.473 34.2758 199.643 34.2758ZM186.808 17.2118C186.808 18.3816 185.859 19.3299 184.69 19.3299C183.52 19.3299 182.572 18.3816 182.572 17.2118C182.572 16.0421 183.52 15.0938 184.69 15.0938C185.859 15.0938 186.808 16.0421 186.808 17.2118ZM199.643 19.3299C200.813 19.3299 201.761 18.3816 201.761 17.2118C201.761 16.0421 200.813 15.0938 199.643 15.0938C198.473 15.0938 197.525 16.0421 197.525 17.2118C197.525 18.3816 198.473 19.3299 199.643 19.3299ZM186.808 2.25865C186.808 3.4284 185.859 4.37668 184.69 4.37668C183.52 4.37668 182.572 3.4284 182.572 2.25865C182.572 1.0889 183.52 0.140625 184.69 0.140625C185.859 0.140625 186.808 1.0889 186.808 2.25865ZM199.643 4.37668C200.813 4.37668 201.761 3.4284 201.761 2.25865C201.761 1.0889 200.813 0.140625 199.643 0.140625C198.473 0.140625 197.525 1.0889 197.525 2.25865C197.525 3.4284 198.473 4.37668 199.643 4.37668ZM216.714 77.0101C216.714 78.1798 215.766 79.1281 214.596 79.1281C213.426 79.1281 212.478 78.1798 212.478 77.0101C212.478 75.8403 213.426 74.892 214.596 74.892C215.766 74.892 216.714 75.8403 216.714 77.0101ZM229.542 79.1281C230.712 79.1281 231.66 78.1798 231.66 77.0101C231.66 75.8403 230.712 74.892 229.542 74.892C228.372 74.892 227.424 75.8403 227.424 77.0101C227.424 78.1798 228.372 79.1281 229.542 79.1281ZM216.714 62.0569C216.714 63.2266 215.766 64.1749 214.596 64.1749C213.426 64.1749 212.478 63.2266 212.478 62.0569C212.478 60.8871 213.426 59.9388 214.596 59.9388C215.766 59.9388 216.714 60.8871 216.714 62.0569ZM229.542 64.1749C230.712 64.1749 231.66 63.2266 231.66 62.0569C231.66 60.8871 230.712 59.9388 229.542 59.9388C228.372 59.9388 227.424 60.8871 227.424 62.0569C227.424 63.2266 228.372 64.1749 229.542 64.1749ZM216.714 47.1109C216.714 48.2807 215.766 49.229 214.596 49.229C213.426 49.229 212.478 48.2807 212.478 47.1109C212.478 45.9412 213.426 44.9929 214.596 44.9929C215.766 44.9929 216.714 45.9412 216.714 47.1109ZM229.542 49.229C230.712 49.229 231.66 48.2807 231.66 47.1109C231.66 45.9412 230.712 44.9929 229.542 44.9929C228.372 44.9929 227.424 45.9412 227.424 47.1109C227.424 48.2807 228.372 49.229 229.542 49.229ZM216.714 32.1578C216.714 33.3275 215.766 34.2758 214.596 34.2758C213.426 34.2758 212.478 33.3275 212.478 32.1578C212.478 30.988 213.426 30.0397 214.596 30.0397C215.766 30.0397 216.714 30.988 216.714 32.1578ZM229.542 34.2758C230.712 34.2758 231.66 33.3275 231.66 32.1578C231.66 30.988 230.712 30.0397 229.542 30.0397C228.372 30.0397 227.424 30.988 227.424 32.1578C227.424 33.3275 228.372 34.2758 229.542 34.2758ZM216.714 17.2118C216.714 18.3816 215.766 19.3299 214.596 19.3299C213.426 19.3299 212.478 18.3816 212.478 17.2118C212.478 16.0421 213.426 15.0938 214.596 15.0938C215.766 15.0938 216.714 16.0421 216.714 17.2118ZM229.542 19.3299C230.712 19.3299 231.66 18.3816 231.66 17.2118C231.66 16.0421 230.712 15.0938 229.542 15.0938C228.372 15.0938 227.424 16.0421 227.424 17.2118C227.424 18.3816 228.372 19.3299 229.542 19.3299ZM216.714 2.25865C216.714 3.4284 215.766 4.37668 214.596 4.37668C213.426 4.37668 212.478 3.4284 212.478 2.25865C212.478 1.0889 213.426 0.140625 214.596 0.140625C215.766 0.140625 216.714 1.0889 216.714 2.25865ZM229.542 4.37668C230.712 4.37668 231.66 3.4284 231.66 2.25865C231.66 1.0889 230.712 0.140625 229.542 0.140625C228.372 0.140625 227.424 1.0889 227.424 2.25865C227.424 3.4284 228.372 4.37668 229.542 4.37668Z",
    fill: "#FDA36F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M164.398 12.0101C164.398 11.2192 165.04 10.5781 165.83 10.5781H241.117C241.907 10.5781 242.549 11.2192 242.549 12.0101V63.7875C242.549 64.5783 241.907 65.2195 241.117 65.2195H170.126C166.963 65.2195 164.398 62.655 164.398 59.4915V12.0101Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2698_24096",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 164,
    y: 10,
    width: 79,
    height: 56
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M164.398 12.0101C164.398 11.2192 165.04 10.5781 165.83 10.5781H241.117C241.907 10.5781 242.549 11.2192 242.549 12.0101V63.7875C242.549 64.5783 241.907 65.2195 241.117 65.2195H170.126C166.963 65.2195 164.398 62.655 164.398 59.4915V12.0101Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2698_24096)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.0547,
    y: 34.75,
    width: 138.664,
    height: 105.144,
    rx: 52.572,
    fill: "url(#paint0_linear_2698_24096)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.962 34.75H119.333C123.449 34.75 127.414 35.3978 131.131 36.597L140.878 52.6227C144.122 57.9563 145.535 64.2034 144.902 70.4138L139.836 120.141L142.793 131.894C141.4 132.971 139.93 133.955 138.394 134.835L132.569 130.035C130.372 128.224 127.122 128.537 125.31 130.735C125.041 131.062 124.813 131.42 124.631 131.803L122.341 136.626L118.796 136.743L119.132 125.83H113.158C111.293 125.83 109.574 126.837 108.661 128.463L104.078 136.626L99.7798 136.743V128.027C99.7798 123.842 100.697 119.708 102.466 115.915L105.937 108.474L97.0464 71.7439C95.3499 64.7353 96.3587 57.3448 99.8715 51.0472L108.962 34.75Z",
    fill: "#E1E8FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 166.031,
    y: 54.5156,
    width: 79.0729,
    height: 60.1642,
    rx: 30.0821,
    fill: "url(#paint1_linear_2698_24096)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.547 137.32H182.653V202.068H110.547V137.32Z",
    fill: "url(#paint2_linear_2698_24096)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.6406 137.32H146.747V202.068H74.6406V137.32Z",
    fill: "url(#paint3_linear_2698_24096)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.624 161.93L213.925 198.757H205.062C207.684 195.586 209.394 191.763 210.012 187.695L213.925 161.93H224.624Z",
    fill: "url(#paint4_linear_2698_24096)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.578 202.129C213.578 202.129 213.641 200.852 213.95 199.869C214.118 199.332 214.515 198.391 214.84 197.649C215.145 196.951 215.151 196.157 214.842 195.461L213.389 197.318C213.122 197.66 212.711 197.86 212.277 197.86H207.468C206.794 197.86 206.42 197.08 206.842 196.555L202.33 200.226C201.561 200.852 201.904 201.948 202.895 201.965C203.278 201.971 203.713 201.975 204.207 201.975C207.212 201.975 211.996 200.26 211.996 200.26L212.442 202.129H213.578Z",
    fill: "url(#paint5_linear_2698_24096)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.762 161.93L237.815 190.185C238.029 192.165 238.529 194.103 239.301 195.938L238.427 198.757H229.565C231.602 196.246 232.315 192.913 231.483 189.788L224.062 161.93H234.762Z",
    fill: "url(#paint6_linear_2698_24096)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.078 202.129C238.078 202.129 238.141 200.852 238.45 199.869C238.618 199.332 239.015 198.391 239.34 197.649C239.645 196.951 239.651 196.157 239.342 195.461L237.889 197.318C237.622 197.66 237.211 197.86 236.777 197.86H231.968C231.294 197.86 230.92 197.08 231.342 196.555L226.83 200.226C226.061 200.852 226.404 201.948 227.395 201.965C227.778 201.971 228.213 201.975 228.707 201.975C231.712 201.975 236.496 200.26 236.496 200.26L236.942 202.129H238.078Z",
    fill: "url(#paint7_linear_2698_24096)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.306 136.468L212.961 162.773H234.838L236.064 152.875C236.976 145.511 237.096 138.07 236.42 130.68L215.306 136.468Z",
    fill: "url(#paint8_linear_2698_24096)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M218.812 162.781L223.944 134.984",
    stroke: "white",
    strokeWidth: 1.1525
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.161 106.469L230.47 118.59C228.365 124.031 222.252 126.727 216.816 124.612C216.571 124.517 216.329 124.412 216.092 124.298L206.358 108.883L212.949 103.866L221.264 114.973L225.837 102.538C226.768 100.008 229.571 98.7143 232.099 99.6491C232.167 99.6742 232.234 99.7008 232.301 99.7289C234.918 100.832 236.186 103.82 235.161 106.469Z",
    fill: "url(#paint9_linear_2698_24096)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.448 105.275C216.642 101.748 219.515 99.0489 223.109 98.0773L229.232 96.4219C232.239 99.068 233.878 102.939 233.684 106.94L233.315 114.58C233.264 115.643 233.358 116.707 233.597 117.743L236.896 132.108L215.289 137.311L216.556 116.604C214.133 115.393 212.975 112.58 213.843 110.015L215.448 105.275Z",
    fill: "url(#paint10_linear_2698_24096)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.719 130.238L216.076 124.404L224.608 105.266L223.382 123.084C223.105 127.112 219.757 130.238 215.719 130.238Z",
    fill: "#0D152A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.494 105.248L204.922 100.415C204.832 100.138 204.595 99.9341 204.308 99.8855C203.921 99.8201 203.545 100.052 203.43 100.428L202.604 103.127C202.604 103.127 201.583 102.331 201.086 101.189C200.932 100.836 200.822 100.398 200.743 99.9353C200.493 98.4709 198.953 97.4378 197.607 98.0675C196.923 98.3879 196.48 99.0699 196.466 99.8256L196.441 101.208C196.388 104.099 197.38 106.912 199.237 109.13L200.091 110.151L206.494 105.248Z",
    fill: "url(#paint11_linear_2698_24096)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M199.654 97.6617C199.654 97.6617 199.312 101.282 200.482 102.681",
    stroke: "#18233D",
    strokeWidth: 1.1525,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M197.084 98.8336C197.084 98.8336 196.742 102.454 197.912 103.853",
    stroke: "#18233D",
    strokeWidth: 1.1525,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M198.467 97.7789C198.467 97.7789 197.887 101.694 199.029 103.127",
    stroke: "#18233D",
    strokeWidth: 1.1525,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.439 102.168C225.054 103.057 226.479 105.872 225.648 108.506L219.623 127.615C217.932 132.978 210.64 133.703 207.926 128.778L197.486 109.83L206.581 105.265L212.386 117.094L215.945 105.488C216.785 102.748 219.725 101.244 222.439 102.168Z",
    fill: "url(#paint12_linear_2698_24096)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.712 84.1318L216.037 83.0064C215.314 82.5203 215.082 81.5618 215.504 80.799C215.92 80.0463 216.837 79.729 217.629 80.0639L218.588 80.4694C218.588 80.4694 223.101 76.8692 226.575 78.9297C230.049 80.9901 230.273 84.9739 232.062 88.4379C233.852 91.9018 238.517 95.8618 236.208 99.5718C233.898 103.282 227.133 102.333 225.932 97.4766C224.731 92.6202 226.034 89.5796 226.034 89.5796L217.712 84.1318Z",
    fill: "url(#paint13_linear_2698_24096)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.18 82.4062L216.577 88.9332C216.352 91.3746 218.127 93.5451 220.565 93.8081L220.218 99.1124L225.914 97.4806L225.602 94.3589C225.438 92.7101 225.587 91.045 226.042 89.4516L227.02 89.9657C227.593 90.267 228.295 90.1647 228.758 89.7125L228.799 89.6726C229.288 89.1951 229.369 88.4375 228.992 87.8674C228.59 87.2606 227.796 87.0537 227.15 87.3878L226.251 87.8523C223.023 87.1677 220.083 85.5084 217.828 83.0988L217.18 82.4062Z",
    fill: "url(#paint14_linear_2698_24096)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.563 93.7964C220.563 93.7964 222.679 93.7849 223.933 92.5781C223.933 92.5781 222.749 96.0415 220.422 96.2303L220.563 93.7964Z",
    fill: "#0D152A"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.422494,
    cy: 0.42246,
    rx: 0.422494,
    ry: 0.42246,
    transform: "matrix(-1 0 0 1 218.32 86.6719)",
    fill: "#18233D"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.422494,
    cy: 0.42246,
    rx: 0.422494,
    ry: 0.42246,
    transform: "matrix(-1 0 0 1 222.117 87.0938)",
    fill: "#18233D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M219.156 87.5156C219.156 87.5156 218.311 88.8393 218.311 89.0224C218.311 89.2055 218.877 89.2055 218.877 89.2055",
    stroke: "#18233D",
    strokeWidth: 1.1525,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.154 90.4766H220.844C220.844 90.4766 220.454 91.3215 219.848 91.3215C219.243 91.3215 219.154 90.4766 219.154 90.4766Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M222.676 86.2733C222.676 86.2733 221.804 85.8211 221.028 86.1396",
    stroke: "#18233D",
    strokeWidth: 1.72875,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M218.508 85.7023C218.508 85.7023 218.056 85.2849 217.26 85.5476",
    stroke: "#18233D",
    strokeWidth: 1.72875,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184 88.0209C183.735 86.5095 184.898 85.125 186.432 85.125H207.54C208.74 85.125 209.766 85.9869 209.973 87.1684L212.333 100.632C212.597 102.144 211.434 103.528 209.9 103.528H188.792C187.592 103.528 186.566 102.666 186.359 101.485L184 88.0209Z",
    fill: "url(#paint15_linear_2698_24096)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.617 88.0209C185.352 86.5095 186.515 85.125 188.049 85.125H209.158C210.357 85.125 211.383 85.9869 211.59 87.1684L213.95 100.632C214.215 102.144 213.052 103.528 211.517 103.528H190.409C189.209 103.528 188.183 102.666 187.976 101.485L185.617 88.0209Z",
    fill: "#E5E9F3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.583 104.073L196.79 100.887C196.441 100.489 195.854 100.405 195.407 100.688C194.927 100.992 194.766 101.616 195.04 102.114L197.382 106.373L200.628 105.691L199.583 104.073Z",
    fill: "url(#paint16_linear_2698_24096)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M197.977 102.359L200.056 104.986H203.981",
    stroke: "#18233D",
    strokeWidth: 1.1525,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.842 104.138L211.386 100.406C211.276 100.124 211.089 99.8797 210.848 99.6991C210.368 99.3409 209.729 99.2776 209.189 99.5347L209.17 99.5435L209.126 99.5137C208.502 99.0887 207.728 98.9447 206.992 99.1168L204.942 95.9254C204.703 95.5532 204.231 95.4071 203.823 95.5793C203.36 95.775 203.144 96.3093 203.34 96.772L205.286 101.358C205.286 102.78 205.651 104.178 206.347 105.419L207.787 107.986L212.842 104.138Z",
    fill: "url(#paint17_linear_2698_24096)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M205.289 101.352L206.574 103.521",
    stroke: "#18233D",
    strokeWidth: 1.1525,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.3516 155.656C78.3942 159.073 81.1435 163.773 82.1411 168.972L87.8188 198.558L92.9738 202.355H74.3516V155.656Z",
    fill: "#0D152A"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8068 177.028L53.8377 170.072L52.4754 163.411C51.6504 159.376 47.2485 157.196 43.5392 158.985L45.126 165.973C46.3877 171.529 49.0786 176.66 52.9323 180.857L59.8068 177.028Z",
    fill: "url(#paint18_linear_2698_24096)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8587 165.257C66.4346 163.312 66.1346 160.457 64.1888 158.882C62.2443 157.308 59.3925 157.608 57.8177 159.552L51.7913 166.99L58.8353 172.691L64.8587 165.257Z",
    fill: "#29CC8B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2698_24096",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 157,
    width: 15,
    height: 16
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8587 165.257C66.4346 163.312 66.1346 160.457 64.1888 158.882C62.2443 157.308 59.3925 157.608 57.8177 159.552L51.7913 166.99L58.8353 172.691L64.8587 165.257Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2698_24096)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.1942 167.312C65.6898 164.232 65.2147 159.712 62.1332 157.218C59.054 154.725 54.5378 155.2 52.044 158.278L42.5619 169.981L53.7169 179.009L63.1942 167.312Z",
    fill: "url(#paint19_linear_2698_24096)"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.088 187.684H53.1114L56.3626 163.791C56.64 161.752 57.6551 159.886 59.2158 158.546C60.4633 157.474 61.9976 156.792 63.6289 156.583L68.7562 155.928C71.0931 155.629 73.4329 156.458 75.0604 158.162C76.4544 159.621 77.1939 161.585 77.1085 163.601L76.088 187.684Z",
    fill: "#29CC8B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.088 187.684H53.1114L56.3626 163.791C56.64 161.752 57.6551 159.886 59.2158 158.546C60.4633 157.474 61.9976 156.792 63.6289 156.583L68.7562 155.928C71.0931 155.629 73.4329 156.458 75.0604 158.162C76.4544 159.621 77.1939 161.585 77.1085 163.601L76.088 187.684Z",
    fill: "url(#paint20_linear_2698_24096)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9972 162.578C68.5408 166.081 68.709 169.637 69.4941 173.081L74.7903 196.319C74.7903 196.319 76.0937 193.107 76.0938 187.681C76.0938 182.255 75.685 163.533 75.685 163.533L68.9972 162.578Z",
    fill: "#0D152A"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.8457 153.791C68.8457 153.791 70.8538 146.583 71.2237 145.126C71.5936 143.67 70.648 142.7 69.3629 143.185C67.9625 141.589 62.4838 139.032 60.2406 139.819C57.9973 140.606 57.2351 144.114 59.8144 145.773C62.3937 147.432 68.8457 153.791 68.8457 153.791Z",
    fill: "url(#paint21_linear_2698_24096)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9893 144.695L59.4359 150.678C59.2286 152.92 60.8585 154.912 63.0963 155.153L62.9671 159.033L70.1853 155.97L68.7139 153.628C68.2513 152.892 68.0442 152.023 68.1246 151.158L69.0235 151.63C69.5491 151.906 70.1926 151.812 70.6176 151.398L70.6553 151.361C71.1046 150.923 71.179 150.227 70.8326 149.704C70.4643 149.147 69.7361 148.958 69.1433 149.264L68.3168 149.691C67.9023 148.391 66.9192 147.35 65.6451 146.862L59.9893 144.695Z",
    fill: "url(#paint22_linear_2698_24096)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.361571,
    cy: 0.36249,
    rx: 0.361571,
    ry: 0.36249,
    transform: "matrix(-1 0 0 1 60.7812 147.586)",
    fill: "#18233D"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.361571,
    cy: 0.36249,
    rx: 0.361571,
    ry: 0.36249,
    transform: "matrix(-1 0 0 1 64.3984 148.305)",
    fill: "#18233D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8594 148.672C61.8594 148.672 61.1362 149.808 61.1362 149.965C61.1362 150.122 61.6207 150.122 61.6207 150.122",
    stroke: "#18233D",
    strokeWidth: 0.987859,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4966 151.57H63.3203C63.3203 151.57 62.8993 152.358 62.246 152.358C61.5927 152.358 61.4966 151.57 61.4966 151.57Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2007 147.288C65.2007 147.288 64.3479 146.851 63.5888 147.159",
    stroke: "#18233D",
    strokeWidth: 1.48179,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1215 146.736C61.1215 146.736 60.6785 146.333 59.8999 146.587",
    stroke: "#18233D",
    strokeWidth: 1.48179,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9966 150.305L69.2162 150.584",
    stroke: "#18233D",
    strokeWidth: 0.987859,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.0737 155.223C63.0737 155.223 64.8956 155.298 65.2031 154.016C65.2031 154.016 64.8133 156.383 63.0337 156.553L63.0737 155.223Z",
    fill: "#0D152A"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.1976 172.031L85.251 198.999L89.8359 202.922H88.3495C82.9581 202.922 78.2458 199.284 76.8812 194.068L71.4341 173.248L79.1976 172.031Z",
    fill: "url(#paint23_linear_2698_24096)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.7606 162.752C77.2424 160.308 74.84 158.748 72.3967 159.268C69.9569 159.788 68.3995 162.186 68.9169 164.627L70.9122 174.038L79.7539 172.154L77.7606 162.752Z",
    fill: "url(#paint24_linear_2698_24096)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.7606 162.76C77.2424 160.316 74.84 158.756 72.3967 159.276C69.9569 159.796 68.3995 162.194 68.9169 164.635L70.9122 174.046L79.7539 172.161L77.7606 162.76Z",
    fill: "#29CC8B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2698_24096",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 159,
    width: 12,
    height: 16
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.7606 162.76C77.2424 160.316 74.84 158.756 72.3967 159.276C69.9569 159.796 68.3995 162.194 68.9169 164.635L70.9122 174.046L79.7539 172.161L77.7606 162.76Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2698_24096)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.4204 150.217C84.3234 145.043 79.237 141.74 74.0639 142.842C68.8983 143.943 65.6011 149.02 66.6965 154.187L70.9074 174.048L89.6272 170.059L85.4204 150.217Z",
    fill: "url(#paint25_linear_2698_24096)"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7854 195.695L10.2747 194.89L7.56744 198.919C3.3138 200.025 0.600588 201.37 1.36241 202.304L16.099 202.57L19.7854 195.695Z",
    fill: "url(#paint26_linear_2698_24096)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9688 189.813L65.4449 195.11C65.0661 198.941 61.7726 201.816 57.9258 201.674C50.7649 201.41 44.2776 197.379 40.8694 191.075L33.7311 177.873L20.6141 197.034L8.04328 195.282L14.9434 183.804C23.9119 168.886 44.3998 166.133 56.988 178.155L64.8162 185.631L65.9688 189.813Z",
    fill: "url(#paint27_linear_2698_24096)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5494 197.05L21.0386 196.25L18.3314 200.25C14.0778 201.349 11.3646 202.684 12.1264 203.612L26.863 203.876L30.5494 197.05Z",
    fill: "url(#paint28_linear_2698_24096)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.0859 190.884L75.5677 196.088C75.1856 199.925 71.8867 202.804 68.0336 202.662C60.8756 202.4 54.3865 198.382 50.9612 192.091L43.8482 179.028L30.7313 198.055L18.1605 196.315L25.089 184.871C34.0656 170.044 54.4442 167.301 67.0211 179.228L74.9333 186.731L76.0859 190.884Z",
    fill: "url(#paint29_linear_2698_24096)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3125 162.719H58.436C58.9498 162.719 59.3663 163.135 59.3663 163.649H46.3125V162.719Z",
    fill: "url(#paint30_linear_2698_24096)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.226 152.907C47.8251 150.812 45.9928 149.297 43.8598 149.297L26.0911 149.297C25.8546 149.297 25.634 149.416 25.504 149.613C25.3987 149.773 25.3632 149.969 25.4056 150.156L28.3419 163.082L49.7919 163.649H50.2812L48.226 152.907Z",
    fill: "url(#paint31_linear_2698_24096)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8741 153.383C47.4762 151.284 45.6423 149.766 43.5065 149.766H27.73C26.4913 149.766 25.5581 150.892 25.7889 152.109L27.0621 158.824C27.5926 161.622 30.0378 163.647 32.8855 163.647H49.8203L47.8741 153.383Z",
    fill: "url(#paint32_linear_2698_24096)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.04896,
    cy: 1.05876,
    rx: 1.04896,
    ry: 1.05876,
    transform: "matrix(-1 0 0 1 38.625 155.656)",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.055 122.242L121.618 126.45C122.034 129.553 124.681 131.87 127.812 131.87C130.837 131.87 133.428 129.703 133.963 126.725L134.768 122.242H121.055Z",
    fill: "url(#paint33_linear_2698_24096)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.405 104.102L147.248 112.864C149.534 116.292 150.9 120.251 151.216 124.359L152.053 135.25C152.11 135.993 151.704 136.696 151.031 137.018C150.282 137.377 149.386 137.179 148.857 136.538L135.922 120.865L141.405 104.102Z",
    fill: "url(#paint34_linear_2698_24096)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.65 104.078L107.807 112.841C105.521 116.269 104.155 120.227 103.839 124.336L103.002 135.226C102.945 135.97 103.351 136.672 104.023 136.995C104.772 137.353 105.669 137.155 106.198 136.515L119.133 120.842L113.65 104.078Z",
    fill: "url(#paint35_linear_2698_24096)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.568 126.403C122.383 126.403 117.872 122.854 116.652 117.814L110.582 92.7392C105.708 72.6007 108.606 51.3646 118.7 33.2694L122.117 27.1434C124.575 22.7365 130.873 22.618 133.495 26.9294L135.814 30.7424C147.71 50.3015 150.924 73.9307 144.685 95.9565L138.374 118.233C137.005 123.067 132.592 126.403 127.568 126.403Z",
    fill: "url(#paint36_linear_2698_24096)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M126.211 57.9242C126.211 56.3222 127.51 55.0234 129.112 55.0234C130.714 55.0234 132.012 56.3222 132.012 57.9242V126.339H126.211V57.9242Z",
    fill: "url(#paint37_linear_2698_24096)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.742 33.2015L125.468 21.1436C126.163 19.8988 127.733 19.4533 128.977 20.1484C129.365 20.3655 129.69 20.6794 129.922 21.0597L137.306 33.2015H118.742Z",
    fill: "url(#paint38_linear_2698_24096)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115.899,
    cy: 63.4148,
    rx: 6.44616,
    ry: 6.45386,
    fill: "url(#paint39_linear_2698_24096)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.602,
    cy: 63.4148,
    rx: 6.44616,
    ry: 6.45386,
    fill: "url(#paint40_linear_2698_24096)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.763,
    cy: 63.5727,
    rx: 4.02885,
    ry: 4.03366,
    fill: "url(#paint41_linear_2698_24096)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M106.531 75.5285H150.405",
    stroke: "#18233D",
    strokeWidth: 2.88125,
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M112.977 101.029H142.992",
    stroke: "#18233D",
    strokeWidth: 2.88125,
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.319 137.306C121.632 137.306 121.087 136.729 121.125 136.043L122.086 118.653C122.15 117.499 122.416 116.365 122.871 115.302L127.667 104.102V120.704L123.475 136.418C123.336 136.941 122.861 137.306 122.319 137.306Z",
    fill: "url(#paint42_linear_2698_24096)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8359 63.1979C71.8359 56.9876 66.8015 51.9531 60.5912 51.9531L50.9327 51.9531C44.7224 51.9531 39.6879 56.9876 39.6879 63.1979C39.6879 69.4082 44.7224 74.4426 50.9327 74.4426H54.1639L57.483 77.1099C58.5604 77.9757 60.1607 77.2087 60.1607 75.8265V74.4426H60.5912C66.8015 74.4426 71.8359 69.4082 71.8359 63.1979Z",
    fill: "url(#paint43_linear_2698_24096)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3281 59.0886H59.3146",
    stroke: "white",
    strokeWidth: 1.64643
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3281 61.9401H51.1931",
    stroke: "white",
    strokeWidth: 1.64643
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3281 64.8073H56.923",
    stroke: "white",
    strokeWidth: 1.64643
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3281 67.6745H62.6529",
    stroke: "white",
    strokeWidth: 1.64643
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3106 158.234V158.234C19.4286 158.234 13.0391 151.845 13.0391 143.963L13.0391 139.499C13.0391 129.157 21.4183 120.771 31.7599 120.763L109.588 120.703",
    stroke: "#18233D",
    strokeWidth: 2.88125,
    strokeDasharray: "8.23 9.06"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M196.915 92.8019H145.407",
    stroke: "#18233D",
    strokeWidth: 2.88125,
    strokeDasharray: "8.23 9.06"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M165.75 201.924H245.969",
    stroke: "#18233D",
    strokeWidth: 1.64643
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.605 183.658L257.465 183.095C256.828 182.927 256.423 182.302 256.53 181.652C256.612 181.159 256.397 180.663 255.982 180.384L255.813 180.27C255.093 179.787 254.891 178.818 255.358 178.088C255.367 178.074 255.375 178.061 255.383 178.048C255.452 177.941 255.452 177.834 255.385 177.726C255.347 177.666 255.302 177.593 255.251 177.512C254.837 176.849 255.081 175.974 255.779 175.622L255.817 175.602C256.421 175.297 257.159 175.514 257.502 176.097L257.628 176.312C257.826 176.649 258.214 176.826 258.599 176.754C259.152 176.651 259.67 177.061 259.696 177.624L259.752 178.813C259.772 179.257 260.157 179.595 260.6 179.558C261.236 179.505 261.666 180.192 261.34 180.74L259.605 183.658Z",
    fill: "#29CC8B"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M258.751 202.614L260.102 184.37L257.062 178.484",
    stroke: "#18233D",
    strokeWidth: 1.64643,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.862 189.944V188.114C258.862 187.472 258.374 186.936 257.736 186.876C257.263 186.831 256.858 186.522 256.689 186.078L256.635 185.934C256.36 185.21 255.577 184.817 254.832 185.029C254.64 185.084 254.505 185.122 254.505 185.122C254.505 185.122 254.336 184.957 254.123 184.748C253.643 184.279 252.874 184.287 252.404 184.767L252.312 184.861C251.884 185.298 251.901 186.002 252.35 186.419L252.525 186.581C252.78 186.818 252.846 187.196 252.685 187.505C252.461 187.937 252.687 188.467 253.153 188.604L254.356 188.959C254.739 189.072 254.944 189.489 254.799 189.861C254.597 190.378 255.064 190.907 255.602 190.77L258.862 189.944Z",
    fill: "#29CC8B"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M259.64 190.424L254.453 186.484",
    stroke: "#18233D",
    strokeWidth: 1.64643,
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.848 185.109V183.278C260.848 182.636 261.337 182.1 261.975 182.04C262.448 181.995 262.853 181.686 263.022 181.242L263.076 181.098C263.351 180.374 264.134 179.981 264.879 180.193C265.071 180.248 265.206 180.286 265.206 180.286C265.206 180.286 265.375 180.121 265.588 179.912C266.068 179.443 266.837 179.451 267.307 179.931L267.399 180.025C267.827 180.462 267.81 181.167 267.361 181.583L267.186 181.745C266.931 181.982 266.865 182.36 267.025 182.669C267.25 183.101 267.024 183.631 266.557 183.768L265.355 184.123C264.972 184.236 264.767 184.653 264.912 185.025C265.114 185.542 264.647 186.071 264.109 185.935L260.848 185.109Z",
    fill: "#29CC8B"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M260.071 185.588L265.258 181.648",
    stroke: "#18233D",
    strokeWidth: 1.64643,
    strokeLinecap: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.281 199.573V197.285C258.281 196.483 257.671 195.812 256.873 195.737C256.282 195.681 255.775 195.295 255.565 194.74L255.497 194.56C255.154 193.655 254.174 193.163 253.243 193.429C253.003 193.497 252.834 193.545 252.834 193.545C252.834 193.545 252.624 193.339 252.357 193.078C251.757 192.491 250.795 192.502 250.209 193.101L250.093 193.219C249.559 193.765 249.58 194.646 250.141 195.166L250.359 195.369C250.678 195.665 250.761 196.137 250.56 196.524C250.279 197.064 250.561 197.726 251.145 197.898L252.648 198.341C253.127 198.482 253.383 199.003 253.202 199.469C252.95 200.115 253.534 200.776 254.206 200.606L258.281 199.573Z",
    fill: "#29CC8B"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.484 195.972V193.683C260.484 192.881 261.095 192.211 261.893 192.135C262.483 192.08 262.991 191.693 263.201 191.139L263.269 190.959C263.612 190.053 264.592 189.562 265.523 189.827C265.763 189.896 265.931 189.944 265.931 189.944C265.931 189.944 266.142 189.737 266.409 189.476C267.008 188.89 267.97 188.9 268.557 189.5L268.672 189.617C269.207 190.164 269.186 191.044 268.625 191.564L268.406 191.767C268.087 192.063 268.005 192.536 268.206 192.922C268.486 193.462 268.204 194.124 267.621 194.296L266.118 194.739C265.638 194.881 265.383 195.402 265.564 195.867C265.816 196.514 265.232 197.174 264.56 197.004L260.484 195.972Z",
    fill: "#29CC8B"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M259.203 197.114L267.26 191.099",
    stroke: "#18233D",
    strokeWidth: 1.64643,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M258.866 199.824L251.535 194.523",
    stroke: "#18233D",
    strokeWidth: 1.64643,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2698_24096",
    x1: 19.0547,
    y1: 34.75,
    x2: 19.0547,
    y2: 139.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2698_24096",
    x1: 166.031,
    y1: 54.5156,
    x2: 166.031,
    y2: 114.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2698_24096",
    x1: 110.547,
    y1: 137.32,
    x2: 110.547,
    y2: 202.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#437B9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FB0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2698_24096",
    x1: 74.6406,
    y1: 137.32,
    x2: 74.6406,
    y2: 202.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FB0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2698_24096",
    x1: 205.062,
    y1: 161.93,
    x2: 205.062,
    y2: 198.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2698_24096",
    x1: 201.008,
    y1: 195.461,
    x2: 201.008,
    y2: 202.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#354970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18233D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2698_24096",
    x1: 224.062,
    y1: 161.93,
    x2: 224.062,
    y2: 198.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2698_24096",
    x1: 225.508,
    y1: 195.461,
    x2: 225.508,
    y2: 202.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#354970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18233D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2698_24096",
    x1: 212.961,
    y1: 130.68,
    x2: 212.961,
    y2: 162.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A65A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2698_24096",
    x1: 228.564,
    y1: 90.1768,
    x2: 204.497,
    y2: 109.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF555D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B45828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2698_24096",
    x1: 200.044,
    y1: 116.867,
    x2: 236.147,
    y2: 138.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCFAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7932"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2698_24096",
    x1: 208.164,
    y1: 103.578,
    x2: 200.841,
    y2: 110.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2698_24096",
    x1: 237.227,
    y1: 119.697,
    x2: 203.947,
    y2: 140.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCFAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7932"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2698_24096",
    x1: 215.289,
    y1: 78.1797,
    x2: 215.289,
    y2: 101.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A65A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2698_24096",
    x1: 229.234,
    y1: 82.4062,
    x2: 229.234,
    y2: 99.1124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2698_24096",
    x1: 183.492,
    y1: 85.125,
    x2: 183.492,
    y2: 103.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#437B9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FB0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2698_24096",
    x1: 196.266,
    y1: 99.9766,
    x2: 200.788,
    y2: 105.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2698_24096",
    x1: 202.984,
    y1: 95.2812,
    x2: 202.984,
    y2: 107.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2698_24096",
    x1: 62.3828,
    y1: 175.016,
    x2: 47.4631,
    y2: 155.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2698_24096",
    x1: 67.7109,
    y1: 161.734,
    x2: 53.7176,
    y2: 179.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79F6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29CC8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2698_24096",
    x1: 77.2422,
    y1: 155.453,
    x2: 77.2422,
    y2: 187.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79F6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29CC8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2698_24096",
    x1: 71.3047,
    y1: 139.672,
    x2: 71.3047,
    y2: 153.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A65A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2698_24096",
    x1: 71.4297,
    y1: 144.695,
    x2: 71.4297,
    y2: 159.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2698_24096",
    x1: 89.8359,
    y1: 172.031,
    x2: 89.8359,
    y2: 202.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2698_24096",
    x1: 76.8203,
    y1: 158.328,
    x2: 79.7597,
    y2: 172.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FB0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2698_24096",
    x1: 83.4297,
    y1: 140.852,
    x2: 89.6395,
    y2: 170.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79F6D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29CC8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2698_24096",
    x1: 18.6406,
    y1: 192.172,
    x2: 21.4538,
    y2: 200.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9AA42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2698_24096",
    x1: 65.9688,
    y1: 160.914,
    x2: 65.9688,
    y2: 201.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A65A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2698_24096",
    x1: 29.4062,
    y1: 193.531,
    x2: 32.2036,
    y2: 202.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9AA42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2698_24096",
    x1: 76.0859,
    y1: 162.188,
    x2: 76.0859,
    y2: 202.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A65A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2698_24096",
    x1: 46.3125,
    y1: 162.719,
    x2: 46.3125,
    y2: 163.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#354970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18233D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2698_24096",
    x1: 50.2812,
    y1: 149.297,
    x2: 50.2812,
    y2: 163.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#354970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18233D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2698_24096",
    x1: 49.8203,
    y1: 149.766,
    x2: 49.8203,
    y2: 163.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9AA42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2698_24096",
    x1: 121.055,
    y1: 122.242,
    x2: 121.055,
    y2: 131.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#354970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18233D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2698_24096",
    x1: 135.922,
    y1: 104.102,
    x2: 135.922,
    y2: 137.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FB0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2698_24096",
    x1: 119.133,
    y1: 104.078,
    x2: 119.133,
    y2: 137.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FB0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2698_24096",
    x1: 103,
    y1: 17.2734,
    x2: 103,
    y2: 126.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2698_24096",
    x1: 126.211,
    y1: 55.0234,
    x2: 126.211,
    y2: 126.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2698_24096",
    x1: 118.742,
    y1: 19.8203,
    x2: 118.742,
    y2: 33.2015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FB0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2698_24096",
    x1: 109.453,
    y1: 56.9609,
    x2: 109.453,
    y2: 69.8687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#437B9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FB0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2698_24096",
    x1: 108.156,
    y1: 56.9609,
    x2: 108.156,
    y2: 69.8687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FB0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2698_24096",
    x1: 110.734,
    y1: 59.5391,
    x2: 110.734,
    y2: 67.6064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2698_24096",
    x1: 121.055,
    y1: 104.102,
    x2: 121.055,
    y2: 137.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FB0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2698_24096",
    x1: 71.8359,
    y1: 51.9531,
    x2: 71.8359,
    y2: 78.6796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD577"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9AA42"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginRightImage);
export default __webpack_public_path__ + "static/media/loginRightImage.d9b1c75ed2078be18301db1b91bbdc0a.svg";
export { ForwardRef as ReactComponent };